module.exports = __webpack_public_path__ + "static/media/arrow-down.d2460df7.svg";